const MenuTitle = (props) => (
  <h2 {...props} className="m-0 p-4 text-sm font-normal" />
);

const MenuButtonContainer = (props) => (
  <div {...props} className="p-4 pb-0 [&_button]:w-full" />
);

const MenuItemContainer = (props) => (
  <div {...props} className="border-borderGray mb-4 border-b" />
);

export { MenuButtonContainer, MenuItemContainer, MenuTitle };
